import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
function PixelLoader() {
  useEffect(() => {
    ;
    (window as any).pixelId = '69f582629c0258fe0e3d8e83';
    const a = document.createElement('script');
    a.setAttribute('async', '');
    a.setAttribute('defer', '');
    a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
    document.head.appendChild(a);
  }, []);
  return null;
}
function Root() {
  return <>
      <PixelLoader data-id="element-232" />
      <App data-id="element-233" />
    </>;
}
render(<Root data-id="element-234" />, document.getElementById('root'));